import React, { useState, useRef, useEffect } from "react";
import Locandina from "../imgs/Locandine/LocandinaScuola.jpg";
import Locandina2 from "../imgs/Locandine/MilarteFaScuola.jpeg";
import Giuseppe from "../imgs/Docenti/giuseppe.jpg";
import Luca from "../imgs/Docenti/Luca Gabbiani.jpg";
import Liliia from "../imgs/Docenti/Liliia Bodnar.jpg";
import Ana from "../imgs/Docenti/Ana Abramovic.jpg";
import Imma from "../imgs/Docenti/Imma Mincolla.jpg";
import Sonia from "../imgs/Docenti/Sonia Franzese.jpg";
import Russo from "../imgs/Docenti/Luca Russo Rossi.jpg";
import Carola from "../imgs/Docenti/Fransca Carola.jpg";
import Silipigni from "../imgs/Docenti/Francesco Silipigni.jpg";
import Fabrizio from "../imgs/Docenti/fabrizio-corbino.jpg";
import Milartefascuola from "../video/milartefascuola.mp4";
import {
  FaSchool,
  FaVolumeUp,
  FaTimes,
  FaSearchPlus,
  FaEnvelope,
  FaCopy,
  FaCheck,
} from "react-icons/fa";
import { useForm } from "@formspree/react";

/* ------------------------------------------------------------------ */
/*  Dati                                                               */
/* ------------------------------------------------------------------ */
const IBAN = "IT19M0760101600001067558849";

const strumenti = [
  "Pianoforte",
  "Chitarra",
  "Violino",
  "Flauto",
  "Chitarra d'accompagnamento",
  "Tastiera",
  "Organo",
  "Clarinetto",
  "Tromba",
  "Violoncello",
  "Coro voci bianche",
];

const docenti = [
  { nome: "Giuseppe Dinardo", img: Giuseppe, strumento: "Flauto" },
  { nome: "Luca Gabbiani", img: Luca, strumento: "Contrabbasso" },
  { nome: "Lilla Bodnar", img: Liliia, strumento: "Violino" },
  { nome: "Ana Abramovic", img: Ana, strumento: "Corno" },
  { nome: "Imma Mincolla", img: Imma, strumento: "Oboe" },
  { nome: "Sonia Franzese", img: Sonia, strumento: "Canto" },
  { nome: "Luca Russo Rossi", img: Russo, strumento: "Violoncello" },
  { nome: "Francesca Carola", img: Carola, strumento: "Pianoforte" },
  { nome: "Francesco Silipigni", img: Silipigni, strumento: "Clarinetto" },
  { nome: "Fabrizio Corbino", img: Fabrizio, strumento: "Trombone" },
];

const inputClass =
  "mt-1 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400";

/* ------------------------------------------------------------------ */
/*  PosterCard                                                         */
/*  Locandina cliccabile con icona lente che invita a ingrandire.      */
/* ------------------------------------------------------------------ */
const PosterCard = ({ src, alt, onOpen }) => (
  <button
    type="button"
    onClick={onOpen}
    aria-label={`Ingrandisci: ${alt}`}
    className="relative w-full rounded-2xl overflow-hidden shadow-lg bg-white cursor-pointer group hover:shadow-2xl transition-shadow duration-500 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-400"
  >
    <img
      src={src}
      alt={alt}
      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
    />
    <span className="absolute bottom-3 right-3 flex items-center justify-center w-10 h-10 rounded-full bg-black/70 text-white text-sm backdrop-blur-sm group-hover:bg-red-600 transition-colors duration-300">
      <FaSearchPlus />
    </span>
  </button>
);

/* ------------------------------------------------------------------ */
/*  VideoPreview                                                       */
/*  Anteprima muta che parte da sola quando la card è visibile e si    */
/*  mette in pausa quando esce dallo schermo. Al click si apre il      */
/*  video in una finestra a tutto schermo, con audio e controlli.      */
/* ------------------------------------------------------------------ */
const VideoPreview = ({ src, onOpen }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const promise = video.play();
          if (promise && promise.catch) promise.catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="Guarda il video con audio"
      className="relative w-full rounded-2xl overflow-hidden shadow-xl bg-black cursor-pointer group focus:outline-none focus-visible:ring-4 focus-visible:ring-red-400"
    >
      <video
        ref={videoRef}
        src={src}
        muted
        loop
        playsInline
        preload="metadata"
        className="w-full max-h-[600px] object-cover group-hover:scale-105 transition-transform duration-700"
      />
      <span className="absolute bottom-3 left-3 flex items-center gap-2 bg-black/70 text-white text-sm font-semibold px-4 py-2 rounded-full backdrop-blur-sm group-hover:bg-red-600 transition-colors duration-300">
        <FaVolumeUp />
        Guarda con audio
      </span>
    </button>
  );
};

/* ------------------------------------------------------------------ */
/*  VideoModal                                                         */
/*  Si chiude con click fuori, pulsante X oppure tasto Esc.            */
/* ------------------------------------------------------------------ */
const VideoModal = ({ src, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Video Milarte fa Scuola"
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Chiudi video"
        className="absolute top-4 right-4 text-white text-3xl p-2 hover:text-red-400 transition-colors"
      >
        <FaTimes />
      </button>
      <video
        src={src}
        controls
        autoPlay
        playsInline
        onClick={(e) => e.stopPropagation()}
        className="max-w-full max-h-full rounded-xl shadow-2xl"
      />
    </div>
  );
};

/* ------------------------------------------------------------------ */
/*  IbanBox: IBAN con pulsante "Copia"                                 */
/* ------------------------------------------------------------------ */
const IbanBox = () => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(t);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(IBAN);
      setCopied(true);
    } catch (e) {
      // Se la copia non è disponibile, l'IBAN resta comunque selezionabile
    }
  };

  return (
    <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 bg-white border border-amber-200 rounded-2xl px-6 py-4 shadow-sm">
      <span className="font-semibold text-gray-800">IBAN</span>
      <span className="font-mono text-red-600 font-bold text-base md:text-lg break-all select-all">
        {IBAN}
      </span>
      <button
        type="button"
        onClick={copy}
        className="inline-flex items-center gap-2 bg-red-600 text-white text-sm font-semibold px-4 py-2 rounded-lg hover:bg-red-700 transition"
      >
        {copied ? <FaCheck /> : <FaCopy />}
        {copied ? "Copiato" : "Copia"}
      </button>
    </div>
  );
};

/* ------------------------------------------------------------------ */
/*  Pagina                                                             */
/* ------------------------------------------------------------------ */
const MilarteFaScuola = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);
  const [state, handleSubmit] = useForm("xvgdpaav");

  const handleImageClick = (image) => setFullScreenImage(image);
  const handleClose = () => setFullScreenImage(null);

  // Chiude l'immagine a schermo intero con il tasto Esc
  useEffect(() => {
    if (!fullScreenImage) return;
    const onKey = (e) => {
      if (e.key === "Escape") setFullScreenImage(null);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [fullScreenImage]);

  return (
    <div className="flex flex-col items-center w-full min-h-screen bg-gradient-to-r from-white to-amber-50 text-gray-800 overflow-hidden">
      <FaSchool className="fixed text-amber-200/40 text-[180px] rotate-12 -top-8 -right-5 z-0" />

      <div className="relative z-10 w-11/12 max-w-6xl">
        {/* --- INTESTAZIONE + INTRO --- */}
        <header className="mt-10 mb-12 max-w-3xl">
          <h1 className="text-red-600 font-extrabold text-4xl md:text-5xl tracking-wide">
            Milarte fa Scuola
          </h1>
          <p className="mt-6 text-lg md:text-xl leading-relaxed text-gray-700">
            MilArte propone la nascita di una scuola di musica, con l’intento di
            diffondere la Bellezza del far musica, alla scoperta di un valore
            aggiunto alla persona. Chiunque può avvicinarsi a questa esperienza,
            a qualsiasi età! Non ultimo MilArte desidera coinvolgere giovani che
            possano dare un contributo significativo alle attività pastorali,
            attraverso l’insegnamento del canto, della chitarra e del
            pianoforte: saranno loro poi gli artefici dei canti della S. Messa.
          </p>
        </header>

        {/* --- LOCANDINE + VIDEO --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center mb-16">
          <PosterCard
            src={Locandina}
            alt="Locandina Scuola di Musica"
            onOpen={() => handleImageClick(Locandina)}
          />
          <PosterCard
            src={Locandina2}
            alt="Locandina Milarte fa Scuola"
            onOpen={() => handleImageClick(Locandina2)}
          />
          <VideoPreview
            src={Milartefascuola}
            onOpen={() => setVideoOpen(true)}
          />
        </div>

        {/* --- STRUMENTI E INFORMAZIONI --- */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-red-600 mb-4">I corsi</h2>
          <p className="text-lg md:text-xl text-gray-700 mb-6">
            Le lezioni si terranno da ottobre 2026 a marzo 2027 per i seguenti
            strumenti:
          </p>
          <ul className="flex flex-wrap gap-3 mb-10">
            {strumenti.map((strumento) => (
              <li
                key={strumento}
                className="bg-white border border-amber-200 text-gray-800 font-medium px-4 py-2 rounded-full shadow-sm"
              >
                {strumento}
              </li>
            ))}
          </ul>

          <div className="bg-amber-100/70 border border-amber-200 rounded-3xl p-6 md:p-10">
            <p className="text-lg md:text-xl leading-relaxed text-gray-800">
              Le lezioni saranno settimanali di 45 minuti presso i locali
              dell’oratorio di S Luigi.
            </p>
            <p className="mt-4 text-lg md:text-xl text-gray-800">
              Per informazioni scrivere a:
            </p>
            <div className="mt-3 flex flex-col sm:flex-row gap-3 sm:gap-8">
              <a
                href="mailto:milarte.mi@gmail.com"
                className="inline-flex items-center gap-2 text-red-600 font-semibold underline underline-offset-4 hover:text-red-500"
              >
                <FaEnvelope /> milarte.mi@gmail.com
              </a>
              <a
                href="mailto:milarte.mi@pec.it"
                className="inline-flex items-center gap-2 text-red-600 font-semibold underline underline-offset-4 hover:text-red-500"
              >
                <FaEnvelope /> milarte.mi@pec.it
              </a>
            </div>
          </div>
        </section>

        {/* --- DOCENTI --- */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-red-600 mb-8">Docenti</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-10">
            {docenti.map((docente) => (
              <div
                key={docente.nome}
                className="flex flex-col items-center text-center"
              >
                <img
                  src={docente.img}
                  alt={docente.nome}
                  className="w-28 h-28 md:w-32 md:h-32 object-cover rounded-full shadow-md ring-4 ring-amber-200/60"
                />
                <p className="mt-3 font-semibold text-base text-gray-900">
                  {docente.nome}
                </p>
                <p className="text-sm text-red-600 font-medium">
                  Docente di {docente.strumento}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* --- ISCRIZIONE --- */}
        <section className="mb-16 flex flex-col items-center text-center">
          <h2 className="text-3xl font-bold text-red-600 mb-6">
            Iscrizione alla Scuola di Musica
          </h2>

          {state.succeeded ? (
            <p className="text-green-600 text-lg font-semibold">
              ✅ Grazie per aver inviato la tua iscrizione! Ti contatteremo
              presto.
            </p>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-4xl bg-white p-6 md:p-10 rounded-3xl shadow-lg text-left text-base"
            >
              <input
                type="hidden"
                name="_subject"
                value="Nuova iscrizione Milarte"
              />

              {/* --- GENITORE --- */}
              <h3 className="col-span-full text-xl font-semibold text-gray-800 border-b border-gray-300 pb-1 mb-2">
                Dati del Genitore
              </h3>

              <div className="flex flex-col">
                <label
                  htmlFor="genitore-nome"
                  className="text-sm font-medium text-gray-700"
                >
                  Nome e Cognome<span className="text-red-600">*</span>
                </label>
                <input
                  id="genitore-nome"
                  name="Nominativo Genitore"
                  type="text"
                  required
                  placeholder="Es. Mario Rossi"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col">
                <label
                  htmlFor="genitore-telefono"
                  className="text-sm font-medium text-gray-700"
                >
                  Numero di Telefono<span className="text-red-600">*</span>
                </label>
                <input
                  id="genitore-telefono"
                  name="Numero Telefono Genitore"
                  type="tel"
                  required
                  placeholder="Es. +39 333 1234567"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col sm:col-span-2">
                <label
                  htmlFor="genitore-email"
                  className="text-sm font-medium text-gray-700"
                >
                  Email<span className="text-red-600">*</span>
                </label>
                <input
                  id="genitore-email"
                  name="Email Genitore"
                  type="email"
                  required
                  placeholder="genitore@email.it"
                  className={inputClass}
                />
              </div>

              {/* --- FIGLIO/A --- */}
              <h3 className="col-span-full text-xl font-semibold text-gray-800 border-b border-gray-300 pb-1 mt-4 mb-2">
                Dati del Figlio/a
              </h3>

              <div className="flex flex-col">
                <label
                  htmlFor="figlio-nome"
                  className="text-sm font-medium text-gray-700"
                >
                  Nome e Cognome<span className="text-red-600">*</span>
                </label>
                <input
                  id="figlio-nome"
                  name="Nome Figlio/a"
                  type="text"
                  required
                  placeholder="Es. Anna Rossi"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col">
                <label
                  htmlFor="figlio-telefono"
                  className="text-sm font-medium text-gray-700"
                >
                  Numero di Telefono
                </label>
                <input
                  id="figlio-telefono"
                  name="Telefono Figlio/a"
                  type="tel"
                  placeholder="Es. +39 333 1234567"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col sm:col-span-2">
                <label
                  htmlFor="figlio-email"
                  className="text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  id="figlio-email"
                  name="Email Figlio/a"
                  type="email"
                  placeholder="figlio@gmail.com"
                  className={inputClass}
                />
              </div>

              {/* --- NOTE --- */}
              <div className="flex flex-col sm:col-span-2">
                <label
                  htmlFor="note"
                  className="text-sm font-medium text-gray-700"
                >
                  Note aggiuntive
                </label>
                <textarea
                  id="note"
                  name="Note"
                  rows="4"
                  placeholder="Es. Strumento preferito, orari disponibili, altre informazioni..."
                  className={inputClass}
                />
              </div>

              {/* --- BOTTONE --- */}
              <div className="col-span-full flex justify-center mt-4">
                <button
                  type="submit"
                  disabled={state.submitting}
                  className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition disabled:opacity-50 font-semibold"
                >
                  Invia Iscrizione
                </button>
              </div>
            </form>
          )}

          <IbanBox />
        </section>
      </div>

      {/* --- IMMAGINE A SCHERMO INTERO --- */}
      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
          onClick={handleClose}
          role="dialog"
          aria-modal="true"
        >
          <img
            src={fullScreenImage}
            className="max-w-[90vw] max-h-[90vh] rounded-2xl shadow-2xl"
            alt="Locandina a schermo intero"
          />
        </div>
      )}

      {videoOpen && (
        <VideoModal
          src={Milartefascuola}
          onClose={() => setVideoOpen(false)}
        />
      )}
    </div>
  );
};

export default MilarteFaScuola;